// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-message-system: #d1d5db; /* Default text color */
  --loader-bg-color: #f3f3f3;      /* Light gray border color */
  --loader-color: #3498db;         /* Light blue spinner color */
  --bg-chat-input-bar-light: #E0E8F0;
  --bg-chat-input-bar-dark: #333; /* example dark background */
}

/* Container for the entire ChatArea */
.chat-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%; /* fill parent container's height */
  /* background-color: #343541; */
  background-color: var(--bg-main);
  color: #d1d5db;
  overflow: hidden;
}

/* Scrollable chat content */
.chat-content {
  flex: 1 1; /* fill remaining space */
  overflow-y: auto;
  padding: 1rem;
  box-sizing: border-box;
  /* ... scroll styles omitted for brevity ... */

  /* NEW: Add safe-area inset to avoid overlap with the fixed input on iPhone */
  /* This ensures that there's enough space at the bottom on iOS Safari */
}
  
/* Custom scrollbar styling for WebKit browsers */
.chat-content::-webkit-scrollbar {
  width: 6px;
  background: transparent;
}
.chat-content::-webkit-scrollbar-track {
  background: none;
}
.chat-content::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color);
  border-radius: 4px;
  border: 1px solid transparent; /* Updated from 'none' to 'transparent' */
}
.chat-content:hover::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color-hover);
}

/* Highlighted chat input container with no horizontal padding */
/* Chat input container with light background and border highlight */
.chat-input-bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0;  /* Vertical padding only */
  background-color: var(--bg-chat-input-bar); /* Light color background */
  border: 0px solid #ccc;  /* Subtle border highlight */
  border-radius: 8px;
  margin: 0;  /* No horizontal margin */
}

/* Multiline text area integrated into the container */
.chat-textarea {
  flex: 1 1;
  resize: none;
  background-color: transparent; /* Inherit the container's background */
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  border: none;
  outline: none;
  color: var(--color-message-system);
  font-size: 16px;
  line-height: 1.4;
  padding: 0.75rem;
}

/* Placeholder text color */
.chat-textarea::placeholder,
.chat-textarea::-webkit-input-placeholder,
.chat-textarea:-ms-input-placeholder {
  color: #007bff;
}

/* Send button styling */
.send-button {
  background-color: #87CEFA;
  border: none;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.send-button:hover:not(:disabled) {
  background-color: #70b6e0;
}

.send-button:disabled {
  background-color: #7a7a7a;
  cursor: not-allowed;
}


/* Style the assistant icon to be circular */
.assistant-icon {
  width: 32px;       /* adjust as desired */
  height: 32px;      /* adjust as desired */
  border-radius: 50%;
  object-fit: cover; /* ensures the image fits the circle nicely */
  margin-right: 8px; /* space between icon and text */
  margin-top: 2px;   /* optional: tweak vertical alignment */
  filter: none !important; /* ensure original colors are retained */
}

/* Message bubble styling */
.message {
  margin: 2.5rem 0;
  padding: 1rem;
  border-radius: 8px;
  line-height: 1.5;
  word-wrap: break-word;
  font-size: 16px;
}

/* Intro/system messages */
.message.system {
  /* background-color: #4f4f5b; */
  background-color: var(--bg-header-sidebar);
  color: var(--color-message-system);
  margin: 1rem auto;
  /* max-width: 85%; */
  border: 1px solid var(--color-border-message-system);
}

/* Legacy Alternative Styles (Commented Out) */
/*
  Type 1:

  .message.assistant {
    background-color: #444654;
    color: var(--color-message-system);
    margin: 1rem auto;
    max-width: 75%;
    text-align: left;
  }

  .message.user {
    background-color: var(--bg-message-user);
    border-radius: 25px;
    color: var(--color-message-system);
    margin-left: auto;
    padding: 10px 30px;
    margin-right: 0;
    max-width: 85%;
  }

  Type 2 -- like ChatGPT:

  .message.assistant {
    color: var(--color-message-system);
    margin-left: 1rem;
    margin-right: auto;
    text-align: left;
    max-width: 90%;
    width: fit-content;
  }

  .message.user {
    background-color: var(--bg-message-user);
    border-radius: 18px 18px 4px 18px;
    color: var(--color-message-system);
    margin-left: auto;
    margin-right: 1rem;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    padding: 12px 16px;
    max-width: 80%;
    width: fit-content;
    box-shadow: 0 1px 3px rgba(0,0,0,0,0.1);
  }

  @media screen and (max-width: 768px) {
    .message.assistant {
      max-width: 90%;
      margin-right: 0.5rem;
      margin-left: 0.5rem;
      padding: 10px 14px;
    }
  }
*/

/* Current Message Layout */
.message-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.chat-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 85%;
  height: 100%;
}

.message.assistant {
  color: var(--color-message-system);
  text-align: left;
  margin: 1rem 0;
}

.assistant-text {
  flex: 1 1; /* Takes the remaining horizontal space */
  display: block; /* Let the text wrap normally */
}

/* User messages: right aligned */
.message.user {
  background-color: var(--bg-message-user);
  border-radius: 18px 18px 4px 18px;
  color: var(--color-message-system);
  padding: 10px 30px;
  margin: 0.75rem 0;
  max-width: fit-content;
  box-shadow: 0 1px 3px rgba(0,0,0,0,0.1);
}

/* Responsive adjustments for message layout */
@media screen and (max-width: 768px) {
  .chat-container {
    width: 100%;
  }

  .chat-input-bar {
    padding: 0.75rem 0; /* Keep vertical padding only */
    margin: 0;         /* Remove horizontal margin */
  }

  .message.assistant {
    max-width: 90%;
  }

  .think-text-container {
    width: 90%;
  }

  .chat-input-fixed {
    position: fixed;
    /* Keep the bottom at 0, but add padding to respect the safe-area */
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--bg-chat-input-bar);
    z-index: 100;

    /* NEW: Provide some bottom padding for iOS safe-area insets */
    padding-bottom: calc(0rem + env(safe-area-inset-bottom));
  }
}

/* Error messages in red */
.message.error {
  background-color: #ffcccc;
  color: #a00;
  margin: 1rem auto;
  max-width: 75%;
}

/* Markdown styling within messages */
.message p {
  margin: 0.5em 0;
  line-height: 1.5;
}
.message ul {
  margin: 0.5em 0;
  padding-left: 1.2em;
}
.message li {
  margin-bottom: 0.3em;
}

/* Table styling for GFM tables */
.message table {
  width: 100%;
  border-collapse: collapse;
  margin: 1em 0;
}
.message th,
.message td {
  border: 1px solid #666;
  padding: 0.5em;
}
.message th {
  background-color: #555;
  color: #fff;
}

/* Spinner container */
.spinner {
  display: flex;
  align-items: center; /* Vertically center the spinner and text */
  gap: 10px; /* Space between circle and text */
}

/* Small circular loader animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  border: 3px solid var(--loader-bg-color, #f3f3f3); /* Light gray border */
  border-top: 3px solid var(--loader-color, #3498db); /* Light blue spinner color */
  border-radius: 50%;
  width: 20px; /* Small size */
  height: 20px;
  animation: spin 1s linear infinite; /* Smooth spinning animation */
}

/* Text styling */
.spinner p {
  margin: 0;
  font-size: 14px;
  color: var(--color-message-system);
}

/* Additional Responsive Adjustments */
@media screen and (max-width: 768px) {
  .message.system {
    max-width: 90%;
  }

  /* NEW: Provide extra bottom padding in the chat content for safe-area */
  .chat-content {
    padding: 0.5rem;
    max-width: 100%;
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
  }

  .message {
    font-size: 15px;
    padding: 0.75rem;
    max-width: 90%;
  }

  .chat-input-bar {
    align-items: stretch;
  }

  .chat-textarea {
    font-size: 15px;
    padding: 0.5rem;
    max-height: 150px;
  }

  .send-button {
    padding: 0.5rem 1rem;
    font-size: 14px;
  }

  .avatar-assistant {
    width: 28px;
    height: 28px;
    margin-right: 6px;
  }

  .assistant-icon {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
    filter: none !important;
  }

  .message-text-container {
    display: flex;
    align-items: flex-start;
  }

  .spinner {
    flex-direction: row;
    gap: 8px;
    align-items: center;
    font-size: 13px;
  }

  .loader {
    width: 18px;
    height: 18px;
  }

  .think-text-container {
    width: 100%;
    padding: 0.5rem;
  }
}

/* Message text container styling */
.message-text-container {
  display: flex;
  text-align: left;
}

.message-text-text {
  display: flex;
  flex-direction: column;
  margin: 0;
}

/* Avatar Styling */
.avatar-assistant {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.assistant-icon {
  width: 32px; /* explicit width */
  height: 32px; /* explicit height */
  border-radius: 50%;
  object-fit: cover; /* prevent squeezing */
  filter: none !important;
}

/* Think text container styling */
.think-text-container {
  /* background-color: tomato; */
  display: flex;
  width: 75%;
}

/* Also align items to the left inside the assistant container */
.message-container.assistant .chat-container {
  align-items: flex-start; /* Instead of flex-end or center */
}`, "",{"version":3,"sources":["webpack://./src/components/ChatArea.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B,EAAE,uBAAuB;EACxD,0BAA0B,OAAO,4BAA4B;EAC7D,uBAAuB,UAAU,6BAA6B;EAC9D,kCAAkC;EAClC,8BAA8B,EAAE,4BAA4B;AAC9D;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,mCAAmC;EACjD,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,SAAO,EAAE,yBAAyB;EAClC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8CAA8C;;EAE9C,6EAA6E;EAC7E,uEAAuE;AACzE;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B,EAAE,yCAAyC;AAC1E;AACA;EACE,8CAA8C;AAChD;;AAEA,gEAAgE;AAChE,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB,GAAG,0BAA0B;EAC/C,0CAA0C,EAAE,2BAA2B;EACvE,sBAAsB,GAAG,4BAA4B;EACrD,kBAAkB;EAClB,SAAS,GAAG,yBAAyB;AACvC;;AAEA,sDAAsD;AACtD;EACE,SAAO;EACP,YAAY;EACZ,6BAA6B,EAAE,uCAAuC;EACtE;wEACsE;EACtE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;;EAGE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA,4CAA4C;AAC5C;EACE,WAAW,QAAQ,sBAAsB;EACzC,YAAY,OAAO,sBAAsB;EACzC,kBAAkB;EAClB,iBAAiB,EAAE,6CAA6C;EAChE,iBAAiB,EAAE,gCAAgC;EACnD,eAAe,IAAI,uCAAuC;EAC1D,uBAAuB,EAAE,wCAAwC;AACnE;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA,8CAA8C;AAC9C;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC;;AAED,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO,EAAE,yCAAyC;EAClD,cAAc,EAAE,+BAA+B;AACjD;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;EACxC,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA,8CAA8C;AAC9C;EACE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB,EAAE,+BAA+B;IACnD,SAAS,UAAU,6BAA6B;EAClD;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mEAAmE;IACnE,SAAS;IACT,OAAO;IACP,QAAQ;IACR,0CAA0C;IAC1C,YAAY;;IAEZ,8DAA8D;IAC9D,wDAAwD;EAC1D;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;AACA;;EAEE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB,EAAE,2CAA2C;EAChE,SAAS,EAAE,kCAAkC;AAC/C;;AAEA,oCAAoC;AACpC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iDAAiD,EAAE,sBAAsB;EACzE,kDAAkD,EAAE,6BAA6B;EACjF,kBAAkB;EAClB,WAAW,EAAE,eAAe;EAC5B,YAAY;EACZ,kCAAkC,EAAE,8BAA8B;AACpE;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;EAChB;;EAEA,wEAAwE;EACxE;IACE,eAAe;IACf,eAAe;IACf,wDAAwD;EAC1D;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW,EAAE,mBAAmB;EAChC,YAAY,EAAE,oBAAoB;EAClC,kBAAkB;EAClB,iBAAiB,EAAE,sBAAsB;EACzC,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;EAC9B,aAAa;EACb,UAAU;AACZ;;AAEA,gEAAgE;AAChE;EACE,uBAAuB,EAAE,kCAAkC;AAC7D","sourcesContent":[":root {\n  --color-message-system: #d1d5db; /* Default text color */\n  --loader-bg-color: #f3f3f3;      /* Light gray border color */\n  --loader-color: #3498db;         /* Light blue spinner color */\n  --bg-chat-input-bar-light: #E0E8F0;\n  --bg-chat-input-bar-dark: #333; /* example dark background */\n}\n\n/* Container for the entire ChatArea */\n.chat-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%; /* fill parent container's height */\n  /* background-color: #343541; */\n  background-color: var(--bg-main);\n  color: #d1d5db;\n  overflow: hidden;\n}\n\n/* Scrollable chat content */\n.chat-content {\n  flex: 1; /* fill remaining space */\n  overflow-y: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n  /* ... scroll styles omitted for brevity ... */\n\n  /* NEW: Add safe-area inset to avoid overlap with the fixed input on iPhone */\n  /* This ensures that there's enough space at the bottom on iOS Safari */\n}\n  \n/* Custom scrollbar styling for WebKit browsers */\n.chat-content::-webkit-scrollbar {\n  width: 6px;\n  background: transparent;\n}\n.chat-content::-webkit-scrollbar-track {\n  background: none;\n}\n.chat-content::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-color);\n  border-radius: 4px;\n  border: 1px solid transparent; /* Updated from 'none' to 'transparent' */\n}\n.chat-content:hover::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-color-hover);\n}\n\n/* Highlighted chat input container with no horizontal padding */\n/* Chat input container with light background and border highlight */\n.chat-input-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 0;  /* Vertical padding only */\n  background-color: var(--bg-chat-input-bar); /* Light color background */\n  border: 0px solid #ccc;  /* Subtle border highlight */\n  border-radius: 8px;\n  margin: 0;  /* No horizontal margin */\n}\n\n/* Multiline text area integrated into the container */\n.chat-textarea {\n  flex: 1;\n  resize: none;\n  background-color: transparent; /* Inherit the container's background */\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  border: none;\n  outline: none;\n  color: var(--color-message-system);\n  font-size: 16px;\n  line-height: 1.4;\n  padding: 0.75rem;\n}\n\n/* Placeholder text color */\n.chat-textarea::placeholder,\n.chat-textarea::-webkit-input-placeholder,\n.chat-textarea:-ms-input-placeholder {\n  color: #007bff;\n}\n\n/* Send button styling */\n.send-button {\n  background-color: #87CEFA;\n  border: none;\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.send-button:hover:not(:disabled) {\n  background-color: #70b6e0;\n}\n\n.send-button:disabled {\n  background-color: #7a7a7a;\n  cursor: not-allowed;\n}\n\n\n/* Style the assistant icon to be circular */\n.assistant-icon {\n  width: 32px;       /* adjust as desired */\n  height: 32px;      /* adjust as desired */\n  border-radius: 50%;\n  object-fit: cover; /* ensures the image fits the circle nicely */\n  margin-right: 8px; /* space between icon and text */\n  margin-top: 2px;   /* optional: tweak vertical alignment */\n  filter: none !important; /* ensure original colors are retained */\n}\n\n/* Message bubble styling */\n.message {\n  margin: 2.5rem 0;\n  padding: 1rem;\n  border-radius: 8px;\n  line-height: 1.5;\n  word-wrap: break-word;\n  font-size: 16px;\n}\n\n/* Intro/system messages */\n.message.system {\n  /* background-color: #4f4f5b; */\n  background-color: var(--bg-header-sidebar);\n  color: var(--color-message-system);\n  margin: 1rem auto;\n  /* max-width: 85%; */\n  border: 1px solid var(--color-border-message-system);\n}\n\n/* Legacy Alternative Styles (Commented Out) */\n/*\n  Type 1:\n\n  .message.assistant {\n    background-color: #444654;\n    color: var(--color-message-system);\n    margin: 1rem auto;\n    max-width: 75%;\n    text-align: left;\n  }\n\n  .message.user {\n    background-color: var(--bg-message-user);\n    border-radius: 25px;\n    color: var(--color-message-system);\n    margin-left: auto;\n    padding: 10px 30px;\n    margin-right: 0;\n    max-width: 85%;\n  }\n\n  Type 2 -- like ChatGPT:\n\n  .message.assistant {\n    color: var(--color-message-system);\n    margin-left: 1rem;\n    margin-right: auto;\n    text-align: left;\n    max-width: 90%;\n    width: fit-content;\n  }\n\n  .message.user {\n    background-color: var(--bg-message-user);\n    border-radius: 18px 18px 4px 18px;\n    color: var(--color-message-system);\n    margin-left: auto;\n    margin-right: 1rem;\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n    padding: 12px 16px;\n    max-width: 80%;\n    width: fit-content;\n    box-shadow: 0 1px 3px rgba(0,0,0,0,0.1);\n  }\n\n  @media screen and (max-width: 768px) {\n    .message.assistant {\n      max-width: 90%;\n      margin-right: 0.5rem;\n      margin-left: 0.5rem;\n      padding: 10px 14px;\n    }\n  }\n*/\n\n/* Current Message Layout */\n.message-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 85%;\n  height: 100%;\n}\n\n.message.assistant {\n  color: var(--color-message-system);\n  text-align: left;\n  margin: 1rem 0;\n}\n\n.assistant-text {\n  flex: 1; /* Takes the remaining horizontal space */\n  display: block; /* Let the text wrap normally */\n}\n\n/* User messages: right aligned */\n.message.user {\n  background-color: var(--bg-message-user);\n  border-radius: 18px 18px 4px 18px;\n  color: var(--color-message-system);\n  padding: 10px 30px;\n  margin: 0.75rem 0;\n  max-width: fit-content;\n  box-shadow: 0 1px 3px rgba(0,0,0,0,0.1);\n}\n\n/* Responsive adjustments for message layout */\n@media screen and (max-width: 768px) {\n  .chat-container {\n    width: 100%;\n  }\n\n  .chat-input-bar {\n    padding: 0.75rem 0; /* Keep vertical padding only */\n    margin: 0;         /* Remove horizontal margin */\n  }\n\n  .message.assistant {\n    max-width: 90%;\n  }\n\n  .think-text-container {\n    width: 90%;\n  }\n\n  .chat-input-fixed {\n    position: fixed;\n    /* Keep the bottom at 0, but add padding to respect the safe-area */\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: var(--bg-chat-input-bar);\n    z-index: 100;\n\n    /* NEW: Provide some bottom padding for iOS safe-area insets */\n    padding-bottom: calc(0rem + env(safe-area-inset-bottom));\n  }\n}\n\n/* Error messages in red */\n.message.error {\n  background-color: #ffcccc;\n  color: #a00;\n  margin: 1rem auto;\n  max-width: 75%;\n}\n\n/* Markdown styling within messages */\n.message p {\n  margin: 0.5em 0;\n  line-height: 1.5;\n}\n.message ul {\n  margin: 0.5em 0;\n  padding-left: 1.2em;\n}\n.message li {\n  margin-bottom: 0.3em;\n}\n\n/* Table styling for GFM tables */\n.message table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1em 0;\n}\n.message th,\n.message td {\n  border: 1px solid #666;\n  padding: 0.5em;\n}\n.message th {\n  background-color: #555;\n  color: #fff;\n}\n\n/* Spinner container */\n.spinner {\n  display: flex;\n  align-items: center; /* Vertically center the spinner and text */\n  gap: 10px; /* Space between circle and text */\n}\n\n/* Small circular loader animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader {\n  border: 3px solid var(--loader-bg-color, #f3f3f3); /* Light gray border */\n  border-top: 3px solid var(--loader-color, #3498db); /* Light blue spinner color */\n  border-radius: 50%;\n  width: 20px; /* Small size */\n  height: 20px;\n  animation: spin 1s linear infinite; /* Smooth spinning animation */\n}\n\n/* Text styling */\n.spinner p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--color-message-system);\n}\n\n/* Additional Responsive Adjustments */\n@media screen and (max-width: 768px) {\n  .message.system {\n    max-width: 90%;\n  }\n\n  /* NEW: Provide extra bottom padding in the chat content for safe-area */\n  .chat-content {\n    padding: 0.5rem;\n    max-width: 100%;\n    padding-bottom: calc(60px + env(safe-area-inset-bottom));\n  }\n\n  .message {\n    font-size: 15px;\n    padding: 0.75rem;\n    max-width: 90%;\n  }\n\n  .chat-input-bar {\n    align-items: stretch;\n  }\n\n  .chat-textarea {\n    font-size: 15px;\n    padding: 0.5rem;\n    max-height: 150px;\n  }\n\n  .send-button {\n    padding: 0.5rem 1rem;\n    font-size: 14px;\n  }\n\n  .avatar-assistant {\n    width: 28px;\n    height: 28px;\n    margin-right: 6px;\n  }\n\n  .assistant-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    object-fit: cover;\n    filter: none !important;\n  }\n\n  .message-text-container {\n    display: flex;\n    align-items: flex-start;\n  }\n\n  .spinner {\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n    font-size: 13px;\n  }\n\n  .loader {\n    width: 18px;\n    height: 18px;\n  }\n\n  .think-text-container {\n    width: 100%;\n    padding: 0.5rem;\n  }\n}\n\n/* Message text container styling */\n.message-text-container {\n  display: flex;\n  text-align: left;\n}\n\n.message-text-text {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n}\n\n/* Avatar Styling */\n.avatar-assistant {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n}\n.assistant-icon {\n  width: 32px; /* explicit width */\n  height: 32px; /* explicit height */\n  border-radius: 50%;\n  object-fit: cover; /* prevent squeezing */\n  filter: none !important;\n}\n\n/* Think text container styling */\n.think-text-container {\n  /* background-color: tomato; */\n  display: flex;\n  width: 75%;\n}\n\n/* Also align items to the left inside the assistant container */\n.message-container.assistant .chat-container {\n  align-items: flex-start; /* Instead of flex-end or center */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
